module.exports = __webpack_public_path__ + "33a4cf68fff7330e5999b5cfe53e5a8e.png";


//////////////////
// WEBPACK FOOTER
// ./shared/components/Logo/assets/cetabever/enlexp.png
// module id = 2684
// module chunks = 0